"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeOnlineClaimRequest = void 0;
const OnlineClaimRequest_1 = require("../../OnlineClaimRequest");
class HomeOnlineClaimRequest extends OnlineClaimRequest_1.OnlineClaimRequest {
}
exports.HomeOnlineClaimRequest = HomeOnlineClaimRequest;
//# sourceMappingURL=HomeOnlineClaimRequest.js.map